import styled from "styled-components";
import { LoaderIcon } from "react-hot-toast";

export const RotatingLoaderIcon = styled(LoaderIcon)`
  position: absolute;
  -webkit-transform: rotate(360deg);
  transform: rotate(360deg);
  -webkit-transition-duration: 1s;
  transition-duration: 1s;
  -webkit-transition-delay: now;
  transition-delay: now;
  width: 20px;
  height: 20px;
`;

export const StyledButton = styled.button<{
  disabled?: boolean;
  $isLoading?: boolean;
}>`
  border-radius: ${(props) => props.theme.box.borderRadius};
  background-color: ${(props) => props.theme.colors.accent1};
  font-size: ${(props) => props.theme.fontSizes.small};
  border: none;
  color: ${(props) => props.theme.colors.font.secondary};
  padding: 0.5rem 1rem;
  outline: none;
  cursor: pointer;
  transition: scale 0.2s;
  display: flex;
  gap: 0.2rem;
  justify-content: center;
  align-items: center;
  position: relative;

  ${(p) =>
    (p.disabled || p.$isLoading) &&
    `
          opacity: 0.8;
          cursor: not-allowed;
        `};

  ${(p) =>
    p.$isLoading &&
    `
          color: transparent;
          `}

  &:hover {
    scale: 1.01;
  }

  > svg {
    margin-right: 0.5rem;
    scale: 1.2;
    flex: 0 0 auto;
  }

  > svg[data-icon] {
    margin: 0;
    color: #666666;
  }

  white-space: nowrap;
`;
